/**
 * Move mid-paragraph unboxing photo after the full first paragraph
 * on "What's Actually in the Box" (image was pasted between "legs a" / "nd").
 */
(function () {
  function fixUnboxImage() {
    var root = document.querySelector('.blog-post-content');
    if (!root) return;

    var img = root.querySelector('img[src*="vislund-unboxing-hardware-1"]');
    if (!img) return;

    var p = img.closest('p');
    if (!p || !p.parentNode) return;

    // Already a standalone figure after the paragraph.
    if (p.classList.contains('blog-post-figure')) return;

    var before = '';
    var after = '';
    var found = false;
    var nodes = p.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n === img) {
        found = true;
        continue;
      }
      var t = n.textContent || '';
      if (!found) before += t;
      else after += t;
    }

    // Mid-paragraph only: text on both sides of the image.
    if (!before.trim() || !after.trim()) return;

    var fullText = (p.textContent || '').replace(/\s+/g, ' ').trim();
    var newP = document.createElement('p');
    newP.textContent = fullText;

    var figure = document.createElement('p');
    figure.className = 'blog-post-figure';
    var moved = img.cloneNode(true);
    moved.setAttribute(
      'alt',
      'Vislund TV stand parts laid out on a coffee table before assembly'
    );
    moved.setAttribute('loading', 'lazy');
    figure.appendChild(moved);

    p.parentNode.insertBefore(newP, p);
    p.parentNode.insertBefore(figure, p);
    p.parentNode.removeChild(p);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixUnboxImage);
  } else {
    fixUnboxImage();
  }
})();
